import React from 'react';
import './skeleton.scss';

const BillInfoPopoverSkeleton = () => (
  <div className="bill-info-popover skeleton d-flex flex-column">
    <div className="popover-header">
      <div className="skeleton-box status-badge" />
      <div className="popover-actions d-flex">
        <div className="skeleton-pill" />
        <div className="skeleton-pill" />
      </div>
    </div>

    <div className="skeleton-box title-line" />
    <div className="skeleton-box alias-line" />
    <div className="skeleton-box summary-line" />
    <div className="skeleton-box committees-line" />
  </div>
);

export default BillInfoPopoverSkeleton;
